import passscorelib from './passscorelib.js';

if (typeof exports !== "undefined") {
    exports.pcloudPassScore = passscorelib;
}
